type AppEvent = 'UPDATE_ADMIN_REQUEST_COUNT';

export const AppEvents = {
  // Trigger an event
  emit: (event: AppEvent) => {
    const customEvent = new CustomEvent(event);
    window.dispatchEvent(customEvent);
  },
  // Listen for an event
  subscribe: (event: AppEvent, callback: () => void) => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }
};